import { create } from 'zustand';

import { formatPathWithTrailingSlash } from 'src/Services/Formatters/formatPathWithTrailingSlash';

interface DocumentPathState {
  currentPath: string;
  setPath: (path: string) => void;
  goToParent: () => void;
  reset: () => void;
}

const useDocumentPathStore = create<DocumentPathState>(set => ({
  currentPath: '/',
  setPath: (path: string) => set({ currentPath: formatPathWithTrailingSlash(path) }),
  goToParent: () =>
    set(state => {
      const currentPathParts = state.currentPath.split('/').filter(Boolean);
      if (currentPathParts.length === 0) return state;

      currentPathParts.pop();
      const newPath = `/${currentPathParts.join('/')}`;

      return { currentPath: formatPathWithTrailingSlash(newPath) };
    }),
  reset: () => set({ currentPath: '/' }),
}));

export default useDocumentPathStore;
